import { Actions } from "../constants/actionTypes";
import { getStore } from "../../Utils/storeUtils";
import { takeLatest, call, put } from "redux-saga/effects";
import {
  fetchUserOrgs,
  createOrg,
  apiFetchUserDashboard,
  fetchAllOrgs,
  apiIsValidOrgName,
  fetchOrgById,
  changeOrgName,
  changeOrgOwner,
  deleteOrg,
  changeOrgMemberRole,
  deleteMemberFromOrg,
  getOrgActivities,
  userActivities,
  timelineGraphDetails,
  apiSelectedOrg,
  inviteUsers,
  apiFetchgetChildOrgDetails,
  apiFetchChildOrgs,
  apiOrgImage,
  bulkUsers,
  apiDeleteImage,
  apiChildOrgCountryChange,
  apiValidateChildOrgOtp,
  apiGetChildOrgOtp,
  apiFetchChildDetails,
  apiGetOrgAddress,
} from "../Services/organizations/orgApis.js";

export function* selectedOrgSaga() {
  yield takeLatest(Actions.API_SELECTED_ORG, selectedOrgApi);
}
function* selectedOrgApi(action) {
  const result = yield call(apiSelectedOrg, action.orgId);
  if (result.isApiSuccessful && result.status === 200) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* createOrgSaga() {
  yield takeLatest(Actions.CREATE_ORG, createOrgAction);
}

function* createOrgAction(action) {
  const result = yield call(createOrg, action.orgInfo);

  if (result.isApiSuccessful) {
    action.meta?.onSuccess(result.data);
    getStore().dispatch({ type: Actions.SET_USER_ORGS, data: null });
  } else {
    action.meta?.onError(result.data);
  }
}

export function* getDashboardOrg() {
  yield takeLatest([Actions.API_ORG_DASHBOARD], fetchUserDashboardOrgs);
}

function* fetchUserDashboardOrgs(action) {
  const result = yield call(apiFetchUserDashboard, action);
}

export function* getAllOrgsSaga() {
  yield takeLatest(Actions.FETCH_ALL_ORGS, fetchAllOrgs);
}

export function* getUserOrgsSaga() {
  yield takeLatest([Actions.API_USER_ORGS], fetchUserOrgs);
}

export function* getOrganizationSagas() {
  yield takeLatest([Actions.FETCH_ALL_ORGS], fetchAllOrgs);
}

export function* isValidOrgName() {
  yield takeLatest([Actions.API_IS_VALID_ORG], fetchIsValidOrgName);
}

function* fetchIsValidOrgName(action) {
  const result = yield call(apiIsValidOrgName, action.orgName);
  if (result.isApiSuccessful) {
    result.data ? action.meta.onSuccess() : action.meta.onError();
  } else {
    action.meta.onError();
  }
}

export function* updateSelectedOrgSaga() {
  yield takeLatest(
    Actions.API_GET_SELECTED_ORG_FULL_INFO,
    updateSelectedOrgAction
  );
}

function* updateSelectedOrgAction(action) {
  let selectedOrgInfo = getStore().getState().organizationsInfo.selectedOrg;
  try {
    const result = yield call(
      fetchOrgById,
      action.orgId || selectedOrgInfo.orgId
    );

    if (result.isApiSuccessful) {
      action.meta?.onSuccess();
      result.data.orgName = result.data.name; // Temp fix to handle org name issue between 2 APIs.
      let orgList = getStore().getState().organizationsInfo.userOrgs;

      let selectedOrgIdx = -1;
      orgList?.data.forEach((org, idx) => {
        if (org.orgId === result.data.orgId) {
          selectedOrgIdx = idx;
        }
      });

      if (selectedOrgIdx !== -1) {
        orgList.data[selectedOrgIdx] = result.data;
        yield put({
          type: Actions.SET_USER_ORGS_AND_SELECTED_ORG,
          data: orgList,
          orgInfo: { ...result.data, isApiSuccessful: true },
        });
      } else if (!orgList) {
        yield put({
          type: Actions.SELECT_ORG,
          orgInfo: { ...result.data, isApiSuccessful: true },
        });
      } else {
        yield put({
          type: Actions.SELECT_ORG,
          orgInfo: { isApiSuccessful: false },
        });
      }
    } else {
      action.meta?.onError();
      yield put({
        type: Actions.SELECT_ORG,
        orgInfo: {
          isApiSuccessful: false,
          errorMessage: result?.response?.data?.errorMessage,
        },
      });
    }
  } catch (err) {
    yield put({
      type: Actions.SELECT_ORG,
      orgInfo: { isApiSuccessful: false },
    });
  }
}

export function* changeOrgNameSaga() {
  yield takeLatest(Actions.CHANGE_ORG_NAME, changeOrgNameAction);
}

function* changeOrgNameAction(action) {
  const result = yield call(changeOrgName, action.org, action.orgNewName);

  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
    yield put({ type: Actions.API_GET_SELECTED_ORG_FULL_INFO });
  } else {
    action.meta?.onError();
  }
}

export function* inviteUsersSaga() {
  yield takeLatest(Actions.API_INVITE_USERS, inviteUsersAction);
}

function* inviteUsersAction(action) {
  const result = yield call(
    inviteUsers,
    action.invitedUsers,
    action.org,
    action.domain
  );

  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
    // Toast("Api successful", "Invite users is successful", "success");
    yield put({ type: Actions.API_GET_SELECTED_ORG_FULL_INFO });
  } else {
    action.meta?.onError();
    // Toast("Api failed", "Invite users has failed", "danger");
  }
}

export function* bulkInviteUsersSaga() {
  yield takeLatest(Actions.API_BULK_INVITE_USERS, bulkInviteUsersAction);
}
function* bulkInviteUsersAction(action) {
  const result = yield call(bulkUsers, action.invitedUsers, action.org);

  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
    yield put({ type: Actions.API_GET_SELECTED_ORG_FULL_INFO });
  } else {
    action.meta?.onError();
  }
}

export function* changeOrgOwnerSaga() {
  yield takeLatest(Actions.CHANGE_ORG_OWNER, changeOrgOwnerAction);
}

function* changeOrgOwnerAction(action) {
  const result = yield call(changeOrgOwner, action.org, action.orgNewOwner);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
    yield put({ type: Actions.API_USER_ORGS });
    yield put({ type: Actions.API_GET_SELECTED_ORG_FULL_INFO });
  } else {
    action.meta?.onError();
  }
}

export function* deleteOrgSaga() {
  yield takeLatest(Actions.DELETE_ORG, deleteOrgAction);
}

function* deleteOrgAction(action) {
  const result = yield call(deleteOrg, action.org);

  if (result.isApiSuccessful) {
    action.meta.onSuccess();
    yield put({ type: Actions.API_USER_ORGS });
  } else {
    action.meta.onError();
  }
}

export function* changeOrgMemberRoleSaga() {
  yield takeLatest(Actions.UPDATE_MEMBER_ROLE, changeOrgMemberRoleAction);
}

function* changeOrgMemberRoleAction(action) {
  const result = yield call(
    changeOrgMemberRole,
    action.orgInfo,
    action.member,
    action.newRole
  );

  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
    // Toast("Api successful", "Member role is updated successfully", "success");
    yield put({ type: Actions.API_GET_SELECTED_ORG_FULL_INFO });
  } else {
    action.meta?.onError();
    // Toast("Technical Issue", "Please try again later", "danger");
  }
}

export function* deleteMemberFromOrgSaga() {
  yield takeLatest(Actions.DELETE_MEMBER_FROM_ORG, deleteMemberFromOrgAction);
}

function* deleteMemberFromOrgAction(action) {
  const result = yield call(deleteMemberFromOrg, action.orgInfo, action.member);

  if (result.isApiSuccessful) {
    action.meta.onSuccess();
    yield put({ type: Actions.API_GET_SELECTED_ORG_FULL_INFO });
  } else {
    const errorMessage = result?.data?.response?.data?.errorMessage;
    action.meta.onError(errorMessage);
  }
}

export function* getOrgActivitiesSaga() {
  yield takeLatest(Actions.API_GET_ORG_ACTIVITIES, getOrgActivitiesAction);
}

function* getOrgActivitiesAction(action) {
  const result = yield call(getOrgActivities, action);
  if (result.isApiSuccessful) {
    yield put({
      type: Actions.SET_SELECTED_ORG_ACTIVITY,
      data: { ...result.data, isApiSuccessful: true },
    });
  } else {
    yield put({
      type: Actions.SET_SELECTED_ORG_ACTIVITY,
      data: { isApiSuccessful: false },
    });
  }
}

// individual space activities api

export function* userActivitySaga() {
  yield takeLatest(Actions.API_PERSONAL_USER_ACTIVITIES, userActivityApiAction);
}

function* userActivityApiAction(action) {
  const result = yield call(userActivities, action);
}

// graph

export function* apiTimePeriodGraphData() {
  yield takeLatest([Actions.API_GET_TIMELINEGRAPH_DETAILS], timelineGraph);
}

function* timelineGraph(action) {
  const result = yield call(timelineGraphDetails, action);
}

export function* apiFetchChildOrgsSaga() {
  yield takeLatest(Actions.API_FETCH_CHILD_ORGS, fetchChildOrgs);
}

function* fetchChildOrgs(action) {
  try {
    const { orgName } = action.data;
    const result = yield call(apiFetchChildOrgs, orgName);

    if (result.isApiSuccessful) {
      yield put({ type: Actions.SET_FETCH_CHILD_ORGS, data: result.data });
      if (action.meta?.onSuccess) {
        yield call(action.meta.onSuccess, result.data);
      }
    } else {
      if (action.meta?.onError) {
        yield call(action.meta.onError);
      }
    }
  } catch (err) {
    if (action.meta?.onError) {
      yield call(action.meta.onError);
    }
  }
}

export function* apiFetchChildOrgDetailsSaga() {
  yield takeLatest(Actions.API_FETCH_CHILD_ORG_DETAILS, getChildOrgDetails);
}

function* getChildOrgDetails(action) {
  try {
    const { orgName } = action.data;
    const result = yield call(apiFetchgetChildOrgDetails, orgName);

    if (result.isApiSuccessful) {
      yield put({
        type: Actions.SET_FETCH_CHILD_ORG_DETAILS,
        data: result.data,
      });
      if (action.meta?.onSuccess) {
        yield call(action.meta.onSuccess, result.data);
      }
    } else {
      if (action.meta?.onError) {
        yield call(action.meta.onError);
      }
    }
  } catch (err) {
    if (action.meta?.onError) {
      yield call(action.meta.onError);
    }
  }
}

export function* orgImage() {
  yield takeLatest([Actions.API_ORGANIZATION_IMAGE], imageOrg);
}

function* imageOrg(action) {
  const result = yield call(apiOrgImage, action.data);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* orgImageDelete() {
  yield takeLatest([Actions.API_DELETE_ORG_IMAGE], imageOrgDelete);
}

function* imageOrgDelete(action) {
  const result = yield call(apiDeleteImage, action.data);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* apiGetChildOtpSaga() {
  yield takeLatest(Actions.API_GET_OTP, getOtp);
}

function* getOtp(action) {
  try {
    const { orgId, userId } = action.data;
    const result = yield call(apiGetChildOrgOtp, orgId, userId);

    if (result.isApiSuccessful) {
      yield put({
        type: Actions.SET_OTP,
        data: result.data,
      });
      if (action.meta?.onSuccess) {
        yield call(action.meta.onSuccess, result.data);
      }
    } else {
      if (action.meta?.onError) {
        yield call(action.meta.onError, result.data);
      }
    }
  } catch (err) {
    if (action.meta?.onError) {
      yield call(action.meta.onError, err.message);
    }
  }
}

export function* apiVerifyChildOtpSaga() {
  yield takeLatest(Actions.API_VERIFY_OTP, verifyOtp);
}

function* verifyOtp(action) {
  try {
    const { orgId, userId, otp } = action.data;
    const result = yield call(apiValidateChildOrgOtp, orgId, userId, otp);
    if (result.isApiSuccessful) {
      if (action.meta?.onSuccess) {
        yield call(action.meta.onSuccess, result.data);
      }
    } else {
      if (action.meta?.onError) {
        yield call(action.meta.onError, result.data);
      }
    }
  } catch (err) {
    if (action.meta?.onError) {
      yield call(action.meta.onError, err.message);
    }
  }
}

export function* childOrgCountryChange() {
  yield takeLatest(
    [Actions.API_SET_CHILD_ORG_COUNTRY],
    childOrgCountryChangeApi
  );
}

function* childOrgCountryChangeApi(action) {
  const result = yield call(apiChildOrgCountryChange, action.data);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess(result.data);
  } else {
    action.meta?.onError(false);
  }
}

export function* apiChildOrgs() {
  yield takeLatest([Actions.API_GET_CHILD_PLAN_DETAILS], childDetails);
}

function* childDetails(action) {
  const result = yield call(apiFetchChildDetails, action);
  return result;
}

export function* apiGetOrgAddressSaga() {
  yield takeLatest(Actions.API_GET_ORG_ADDRESS, getOrgAddress);
}

function* getOrgAddress(action) {
  const result = yield call(apiGetOrgAddress, action);
  return result;
}
